/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as NewRouteImport } from './routes/new'
import { Route as MeRouteImport } from './routes/me'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SessionsIndexRouteImport } from './routes/sessions.index'
import { Route as JobsIndexRouteImport } from './routes/jobs.index'
import { Route as VizSlugRouteImport } from './routes/viz.$slug'
import { Route as SessionsSlugRouteImport } from './routes/sessions.$slug'
import { Route as JobsIdRouteImport } from './routes/jobs.$id'
import { Route as SessionsSlugTranscriptRouteImport } from './routes/sessions.$slug.transcript'

const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const NewRoute = NewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => rootRouteImport,
} as any)
const MeRoute = MeRouteImport.update({
  id: '/me',
  path: '/me',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SessionsIndexRoute = SessionsIndexRouteImport.update({
  id: '/sessions/',
  path: '/sessions/',
  getParentRoute: () => rootRouteImport,
} as any)
const JobsIndexRoute = JobsIndexRouteImport.update({
  id: '/jobs/',
  path: '/jobs/',
  getParentRoute: () => rootRouteImport,
} as any)
const VizSlugRoute = VizSlugRouteImport.update({
  id: '/viz/$slug',
  path: '/viz/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const SessionsSlugRoute = SessionsSlugRouteImport.update({
  id: '/sessions/$slug',
  path: '/sessions/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const JobsIdRoute = JobsIdRouteImport.update({
  id: '/jobs/$id',
  path: '/jobs/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const SessionsSlugTranscriptRoute = SessionsSlugTranscriptRouteImport.update({
  id: '/transcript',
  path: '/transcript',
  getParentRoute: () => SessionsSlugRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/me': typeof MeRoute
  '/new': typeof NewRoute
  '/settings': typeof SettingsRoute
  '/jobs/$id': typeof JobsIdRoute
  '/sessions/$slug': typeof SessionsSlugRouteWithChildren
  '/viz/$slug': typeof VizSlugRoute
  '/jobs/': typeof JobsIndexRoute
  '/sessions/': typeof SessionsIndexRoute
  '/sessions/$slug/transcript': typeof SessionsSlugTranscriptRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/me': typeof MeRoute
  '/new': typeof NewRoute
  '/settings': typeof SettingsRoute
  '/jobs/$id': typeof JobsIdRoute
  '/sessions/$slug': typeof SessionsSlugRouteWithChildren
  '/viz/$slug': typeof VizSlugRoute
  '/jobs': typeof JobsIndexRoute
  '/sessions': typeof SessionsIndexRoute
  '/sessions/$slug/transcript': typeof SessionsSlugTranscriptRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/me': typeof MeRoute
  '/new': typeof NewRoute
  '/settings': typeof SettingsRoute
  '/jobs/$id': typeof JobsIdRoute
  '/sessions/$slug': typeof SessionsSlugRouteWithChildren
  '/viz/$slug': typeof VizSlugRoute
  '/jobs/': typeof JobsIndexRoute
  '/sessions/': typeof SessionsIndexRoute
  '/sessions/$slug/transcript': typeof SessionsSlugTranscriptRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/me'
    | '/new'
    | '/settings'
    | '/jobs/$id'
    | '/sessions/$slug'
    | '/viz/$slug'
    | '/jobs/'
    | '/sessions/'
    | '/sessions/$slug/transcript'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/me'
    | '/new'
    | '/settings'
    | '/jobs/$id'
    | '/sessions/$slug'
    | '/viz/$slug'
    | '/jobs'
    | '/sessions'
    | '/sessions/$slug/transcript'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/me'
    | '/new'
    | '/settings'
    | '/jobs/$id'
    | '/sessions/$slug'
    | '/viz/$slug'
    | '/jobs/'
    | '/sessions/'
    | '/sessions/$slug/transcript'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  MeRoute: typeof MeRoute
  NewRoute: typeof NewRoute
  SettingsRoute: typeof SettingsRoute
  JobsIdRoute: typeof JobsIdRoute
  SessionsSlugRoute: typeof SessionsSlugRouteWithChildren
  VizSlugRoute: typeof VizSlugRoute
  JobsIndexRoute: typeof JobsIndexRoute
  SessionsIndexRoute: typeof SessionsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/new': {
      id: '/new'
      path: '/new'
      fullPath: '/new'
      preLoaderRoute: typeof NewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/me': {
      id: '/me'
      path: '/me'
      fullPath: '/me'
      preLoaderRoute: typeof MeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sessions/': {
      id: '/sessions/'
      path: '/sessions'
      fullPath: '/sessions/'
      preLoaderRoute: typeof SessionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/jobs/': {
      id: '/jobs/'
      path: '/jobs'
      fullPath: '/jobs/'
      preLoaderRoute: typeof JobsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/viz/$slug': {
      id: '/viz/$slug'
      path: '/viz/$slug'
      fullPath: '/viz/$slug'
      preLoaderRoute: typeof VizSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sessions/$slug': {
      id: '/sessions/$slug'
      path: '/sessions/$slug'
      fullPath: '/sessions/$slug'
      preLoaderRoute: typeof SessionsSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/jobs/$id': {
      id: '/jobs/$id'
      path: '/jobs/$id'
      fullPath: '/jobs/$id'
      preLoaderRoute: typeof JobsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sessions/$slug/transcript': {
      id: '/sessions/$slug/transcript'
      path: '/transcript'
      fullPath: '/sessions/$slug/transcript'
      preLoaderRoute: typeof SessionsSlugTranscriptRouteImport
      parentRoute: typeof SessionsSlugRoute
    }
  }
}

interface SessionsSlugRouteChildren {
  SessionsSlugTranscriptRoute: typeof SessionsSlugTranscriptRoute
}

const SessionsSlugRouteChildren: SessionsSlugRouteChildren = {
  SessionsSlugTranscriptRoute: SessionsSlugTranscriptRoute,
}

const SessionsSlugRouteWithChildren = SessionsSlugRoute._addFileChildren(
  SessionsSlugRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  MeRoute: MeRoute,
  NewRoute: NewRoute,
  SettingsRoute: SettingsRoute,
  JobsIdRoute: JobsIdRoute,
  SessionsSlugRoute: SessionsSlugRouteWithChildren,
  VizSlugRoute: VizSlugRoute,
  JobsIndexRoute: JobsIndexRoute,
  SessionsIndexRoute: SessionsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
